import type { ReviewEntity } from "../../model";

import type { OrderEntity } from "~/entities/order/@x/review";
import { boolToStr } from "~/shared/no-topic";
import { EMPTY, QUESTION_MARK, SLASH } from "~/shared/str";

const BASE_URL = "comments";
const PAGED = "paged";
const ADMIN = "admin";

const URLS = {
  create: BASE_URL,
  update: BASE_URL,
  delete: (reviewId: ReviewEntity.Schema["id"]) => [BASE_URL, reviewId].join(SLASH),
  approve: ({ id, isApproved }: Pick<ReviewEntity.Schema, "id" | "isApproved">) =>
    [
      BASE_URL,
      ADMIN,
      id,
      "approve",
      [
        QUESTION_MARK,
        new URLSearchParams({
          isApproved: boolToStr(isApproved),
        }).toString(),
      ].join(EMPTY),
    ].join(SLASH),
  get: (reviewId: ReviewEntity.Schema["id"]) => [BASE_URL, reviewId].join(SLASH),
  getForAdmin: (reviewId: ReviewEntity.Schema["id"]) => [BASE_URL, ADMIN, reviewId].join(SLASH),
  getPaginated: [BASE_URL, PAGED].join(SLASH),
  getPaginatedForAdmin: [BASE_URL, ADMIN, PAGED].join(SLASH),
  getByOrder: (orderNumber: OrderEntity.Schema["number"]) =>
    [BASE_URL, "order", orderNumber].join(SLASH),
};

export { URLS };
